import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { buildWhatsAppUrl } from "../context/CartContext";
import { useLang } from "../context/LanguageContext";

export const FloatingWhatsApp = () => {
    const { t } = useLang();
    const url = buildWhatsAppUrl(
        "Hello Kumari Pickles",
    );
    return (
        <motion.a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0, y: 20, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ delay: 1.6, duration: 0.6, ease: [0.19, 1, 0.22, 1] }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.96 }}
            className="fixed bottom-5 right-5 md:bottom-8 md:right-8 z-[65] flex items-center gap-2 bg-[#25D366] text-white pl-3 pr-4 py-3 rounded-full shadow-lg shadow-black/20 group"
            aria-label={t({ en: "Chat on WhatsApp", te: "WhatsApp లో సందేశం" })}
            data-testid="floating-whatsapp"
        >
            <MessageCircle size={18} className="fill-white/20" />
            <span className="hidden md:inline text-[12px] tracking-mono-wide">
                {t({ en: "Chat on WhatsApp", te: "WhatsApp లో" })}
            </span>
        </motion.a>
    );
};
